/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Dock,
  DockInput,
  Docks,
  DocksParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new Dock
 */
export const createDock = (
    dockInput: MaybeRefOrGetter<DockInput>,
 signal?: AbortSignal
) => {
      dockInput = toValue(dockInput);

      return axiosClient<Dock>(
      {url: `/docks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dockInput, signal
    },
      );
    }




export const getCreateDockMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDock>>, TError,{data: DockInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDock>>, TError,{data: DockInput}, TContext> => {

const mutationKey = ['createDock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDock>>, {data: DockInput}> = (props) => {
          const {data} = props ?? {};

          return  createDock(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDockMutationResult = NonNullable<Awaited<ReturnType<typeof createDock>>>
    export type CreateDockMutationBody = DockInput
    export type CreateDockMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create new Dock
 */
export const useCreateDock = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDock>>, TError,{data: DockInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDock>>,
        TError,
        {data: DockInput},
        TContext
      > => {
      return useMutation(getCreateDockMutationOptions(options), queryClient);
    }
    /**
 * @summary Docks list
 */
export const docks = (
    params?: MaybeRefOrGetter<DocksParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Docks>(
      {url: `/docks`, method: 'GET',
        params, signal
    },
      );
    }




export const getDocksQueryKey = (params?: MaybeRefOrGetter<DocksParams>,) => {
    return [
    'docks', ...(params ? [params] : [])
    ] as const;
    }


export const getDocksQueryOptions = <TData = Awaited<ReturnType<typeof docks>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<DocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDocksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof docks>>> = ({ signal }) => docks(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docks>>, TError, TData>
}

export type DocksQueryResult = NonNullable<Awaited<ReturnType<typeof docks>>>
export type DocksQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Docks list
 */

export function useDocks<TData = Awaited<ReturnType<typeof docks>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<DocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof docks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Dock destroy
 */
export const destroyDock = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/docks/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyDockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyDock>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyDock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyDock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyDock(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyDockMutationResult = NonNullable<Awaited<ReturnType<typeof destroyDock>>>

    export type DestroyDockMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Dock destroy
 */
export const useDestroyDock = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDock>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyDock>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyDockMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Dock
 */
export const dock = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Dock>(
      {url: `/docks/${id}`, method: 'GET', signal
    },
      );
    }




export const getDockQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'docks',id
    ] as const;
    }


export const getDockQueryOptions = <TData = Awaited<ReturnType<typeof dock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDockQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dock>>> = ({ signal }) => dock(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dock>>, TError, TData>
}

export type DockQueryResult = NonNullable<Awaited<ReturnType<typeof dock>>>
export type DockQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Dock
 */

export function useDock<TData = Awaited<ReturnType<typeof dock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDockQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Dock
 */
export const updateDock = (
    id: MaybeRefOrGetter<string>,
    dockInput: MaybeRefOrGetter<DockInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
dockInput = toValue(dockInput);

      return axiosClient<Dock>(
      {url: `/docks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: dockInput, signal
    },
      );
    }




export const getUpdateDockMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDock>>, TError,{id: string;data: DockInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDock>>, TError,{id: string;data: DockInput}, TContext> => {

const mutationKey = ['updateDock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDock>>, {id: string;data: DockInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDock(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDockMutationResult = NonNullable<Awaited<ReturnType<typeof updateDock>>>
    export type UpdateDockMutationBody = DockInput
    export type UpdateDockMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Dock
 */
export const useUpdateDock = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDock>>, TError,{id: string;data: DockInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateDock>>,
        TError,
        {id: string;data: DockInput},
        TContext
      > => {
      return useMutation(getUpdateDockMutationOptions(options), queryClient);
    }
